var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 18,
    viewBox: "0 0 37 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 1.01205L9.33122 11.9759V17.8313H5.86604V11.9759L0 1.01205H3.9107L7.62338 8.6988L11.3113 1.01205H15.1725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1159 4.48193V17.8313H26.6259V16.1446C26.1804 16.7229 25.5946 17.1807 24.8686 17.5181C24.1591 17.8394 23.3835 18 22.542 18C21.4694 18 20.5206 17.7831 19.6956 17.3494C18.8706 16.8996 18.2188 16.249 17.7403 15.3976C17.2782 14.5301 17.0472 13.502 17.0472 12.3133V4.48193H20.5124V11.8313C20.5124 12.8916 20.7847 13.7108 21.3292 14.2892C21.8737 14.8514 22.6162 15.1325 23.5568 15.1325C24.5138 15.1325 25.2646 14.8514 25.8092 14.2892C26.3537 13.7108 26.6259 12.8916 26.6259 11.8313V4.48193H30.1159Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 0V17.8313H33.5348V0H37Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYul);
export default __webpack_public_path__ + "static/media/yul.c3c09ad379dbcec6079ef33018522b02.svg";
export { ForwardRef as ReactComponent };